import Button from '@material-ui/core/Button'
import Checkbox from '@material-ui/core/Checkbox'
import { withStyles } from '@material-ui/core/styles'
import React, { Component } from 'react'
import { Col, Modal, Row } from 'react-bootstrap'
import Sample from '../../CommonScreens/sampleTextField'
import customStyle from '../../CSS/stylesheet_UHS'
import i18n from '../i18next'

const CustomeButton = withStyles(customStyle.viewBtn)(Button)

class EnrollNew6 extends Component {
  constructor(props) {
    super(props)
    this.state = {
      modalShow: false,
      authModalShow: false,
      privacyPolicy: this.props.privacyPolicy,
      authorize: this.props.authorize,
      fullName: this.props.viewMode ? this.props.fullName : ''
    }
  }

  componentDidMount() {
    this.handleAgreement()
  }

  authorizeHideModal = event => {
    this.setState(
      {
        authModalShow: false,
        authorize: this.props.viewMode ? true : false
      },
      () => this.handleAgreement
    )
  }

  acceptAuth = () => {
    this.setState(
      {
        authModalShow: false,
        authorize: true
      },
      () => this.handleAgreement()
    )
  }

  showAuthorizeModalPopup = event => {
    this.setState(
      {
        authModalShow: true
        // authorize: this.props.viewMode ? false : true,
        // authorize: this.props.viewMode ? true : false,
      },
      () => this.handleAgreement
    )
  }

  handleAgreement = () => {
    /**/
    if (this.state.privacyPolicy && this.state.authorize && this.state.fullName !== '') {
      this.props.onClick(false, this.state.authorize, this.state.privacyPolicy, this.state.fullName)
    } else {
      this.props.onClick(true, this.state.authorize, this.state.privacyPolicy, this.state.fullName)
    }
  }

  showPlansModalPrivacy = () => {
    this.setState(
      {
        modalShowPrivacy: true
        // privacyPolicy: this.props.viewMode ? true : false,
        // privacyPolicy: this.props.viewMode ? false : true,
        // loaderShow: true
      },
      () => {
        this.handleAgreement()
      }
    )
  }

  hideAllModal = () => {
    this.setState({
      modalShowPrivacy: false,
      authModalShow: false
    })
  }

  hideModalPrivacy = event => {
    // hide and cancel acception
    this.setState(
      {
        modalShowPrivacy: false,
        // privacyPolicy: this.props.viewMode ? true : false,
        privacyPolicy: false
      },
      () => {
        this.handleAgreement()
      }
    )
  }

  acceptPrivacyPolicy = () => {
    this.setState(
      {
        modalShowPrivacy: false,
        privacyPolicy: true
      },
      () => {
        this.handleAgreement()
      }
    )
  }

  nameChangeHandler = (val, isValid, parentObj) => {
    if (isValid) {
      this.setState(
        {
          fullName: val
        },
        () => {
          this.handleAgreement()
        }
      )
    } else {
      this.setState(
        {
          fullName: ''
        },
        () => {
          this.handleAgreement()
        }
      )
    }
  }

  render() {
    return (
      <Row className="d-flex mt-2 card-content">
        <Col md={7} className="px-0 px-md-3">
          <Col md={12} className="px-2 px-md-2">
            <div className="custom-subtitle">Review & accept terms</div>
          </Col>
          {/* <span style={customeClasses.subTitle}>Review & accept terms</span> */}
          <div>
            <Checkbox
              checked={this.state.privacyPolicy}
              inputProps={{
                'aria-label': 'secondary checkbox'
              }}
              disabled={this.props.viewMode}
              style={{ color: '#2e3192' }}
              onClick={this.showPlansModalPrivacy}
            />
            <span style={{ cursor: 'pointer', fontWeight: '400' }} onClick={this.showPlansModalPrivacy}>
              {i18n.t('SUBMIT_APPLICATION.AGREE')}{' '}
              <span
                style={{ color: '#2e3192', cursor: 'pointer', fontWeight: 'bold', borderBottom: '1px solid #2e3192' }}
                onClick={this.showPlansModalPrivacy}
              >
                {i18n.t('SUBMIT_APPLICATION.PRIVACY')}
              </span>
            </span>

            <Modal size="lg" show={this.state.modalShowPrivacy} onHide={event => this.hideAllModal(event)} backdrop="static">
              <Modal.Header style={customStyle.modal_header} closeButton>
                <Modal.Title style={{ fontSize: '1rem', color: "#fff" }}> {i18n.t('SUBMIT_APPLICATION.PRIVACY_TITLE')}</Modal.Title>
              </Modal.Header>
              <Modal.Body style={{ maxHeight: '60vh', overflowY: 'auto', textAlign: 'justify', wordSpacing: '-2px' }}>
                <div dangerouslySetInnerHTML={{
                  __html: `
                    <h1 style="font-size:16pt;text-align:center;margin:0 0 12pt; color:#000000"><b>Privacy Policy</b></h1>
                    <p style="margin:0 0 8pt;text-align:center; color:#595959">Universal Health Fellowship, Inc.&nbsp;&nbsp;&nbsp;•&nbsp;&nbsp;&nbsp;Effective Date: July 21, 2026</p>
                    <p style="font-size:11pt; margin:0 0 8pt;text-align:left; color:#000000;line-height:1.3">Universal Health Fellowship, Inc. ("UHF," "we," "us," or "our") respects the privacy of our members, program participants, website visitors, agents, providers, and other individuals who interact with us. This Privacy Policy describes the personal information we collect, how we use and share it, the choices you have, and your rights under applicable law.</p>
                    <p style="font-size:11pt; margin:0 0 8pt;text-align:left; color:#000000;line-height:1.3">This Policy applies to UHF websites, member and agent portals, mobile and web applications, and other services that link to it (collectively, the "Services"). Where we provide a supplemental or program-specific privacy notice, the more specific notice controls for that program.</p>
                    <h2 style="font-size:13pt; margin:12pt 0 6pt; color:#253760; font-weight:bold">An Important Note About Health Care Sharing</h2>
                    <p style="font-size:11pt; margin:0 0 8pt;text-align:left; color:#000000;line-height:1.3">UHF facilitates a health care cost-sharing program in which members voluntarily share one another's eligible medical expenses. UHF is not an insurance company, and membership is not insurance. A health care sharing ministry is generally not a "covered entity" under HIPAA, so the HIPAA rules that apply to insurers and health care providers generally do not apply to UHF. We nevertheless recognize that the information members share with us — including information about medical needs and conditions — is sensitive, and we protect it as described in this Policy and handle it only as needed to administer the sharing program.</p>
                    <h2 style="font-size:13pt; margin:12pt 0 6pt; color:#253760; font-weight:bold">Information We Collect</h2>
                    <p style="font-size:11pt; margin:0 0 8pt;text-align:left; color:#000000;line-height:1.3">We collect personal information directly from you, automatically through your use of the Services, and from third parties such as agents, brokers, providers, and service partners. Depending on how you interact with us, this may include:</p>
                    <ul style="margin:0 0 8pt; padding-left:40px;text-align:left">
                      <li style="font-size:11pt; margin-bottom:1pt; line-height: 1.3; color:#000000"><strong style="font-weight:bold">Identifiers and contact details —</strong> name, mailing address, email address, telephone number, and account or membership identifiers.</li>
                      <li style="font-size:11pt; margin-bottom:1pt; line-height: 1.3; color:#000000"><strong style="font-weight:bold">Enrollment and membership information —</strong> program selected, membership status, dependents or household members, and eligibility information.</li>
                      <li style="font-size:11pt; margin-bottom:1pt; line-height: 1.3; color:#000000"><strong style="font-weight:bold">Health-related information —</strong> medical needs, conditions, treatment, and expense information submitted in connection with sharing requests, collected only as needed to administer the sharing program.</li>
                      <li style="font-size:11pt; margin-bottom:1pt; line-height: 1.3; color:#000000"><strong style="font-weight:bold">Financial and payment information —</strong> billing details, contribution and payment history, and bank or card information used to process payments.</li>
                      <li style="font-size:11pt; margin-bottom:1pt; line-height: 1.3; color:#000000"><strong style="font-weight:bold">Communications —</strong> records of your communications with us, including customer support interactions.</li>
                      <li style="font-size:11pt; margin-bottom:1pt; line-height: 1.3; color:#000000"><strong style="font-weight:bold">Automatically collected information —</strong> IP address, device and browser information, login activity, and usage information collected through cookies and similar technologies (see "Cookies and Tracking Technologies").</li>
                    </ul>
                    <h2 style="font-size:13pt;margin:12pt 0 6pt; color:#253760; font-weight:bold">How We Use Personal Information</h2>
                    <p style="font-size:11pt;margin:0 0 8pt;text-align:left; color:#000000;line-height:1.3">We use personal information to operate our organization and administer the sharing program, including to: enroll members and administer memberships and eligibility; process, review, and facilitate the sharing of eligible medical expenses; process contributions, payments, and billing; provide customer support; communicate with you about your membership, including account, billing, security, and operational notices; send newsletters and marketing communications where permitted (see "Your Marketing Choices"); maintain security and prevent fraud; conduct analytics and improve our programs and Services; and comply with law and enforce our agreements.</p>
                    <p style="font-size:11pt;margin:0 0 8pt;text-align:left; color:#000000;line-height:1.3">We process personal information as necessary to provide the Services you request, to pursue our legitimate organizational interests consistent with your rights, to comply with legal obligations, and, where required, with your consent.</p>
                    <h2 style="font-size:13pt;margin:12pt 0 6pt; color:#253760; font-weight:bold">Cookies and Tracking Technologies</h2>
                    <p style="font-size:11pt;margin:0 0 8pt;text-align:left; color:#000000;line-height:1.3">Our websites and applications use cookies and similar technologies to operate the site, remember your preferences, understand how visitors use our web properties, and improve your experience. You can control cookies through your browser settings. Where required by law, we honor recognized browser-based opt-out preference signals (such as Global Privacy Control) as a request to opt out of the sale or sharing of personal information and targeted advertising. Disabling some cookies may affect functionality. We do not use advertising or analytics cookies on pages where members submit health-related information.</p>
                    <h2 style="font-size:13pt;margin:12pt 0 6pt; color:#253760; font-weight:bold">How We Share Personal Information</h2>
                    <p style="font-size:11pt;margin:0 0 8pt;text-align:left; color:#000000;line-height:1.3">We do not sell your personal information for money, and we do not "sell" or "share" it for cross-context behavioral advertising as those terms are defined under applicable state privacy laws. We share personal information only as follows:</p> 
                    <ul style="margin:0 0 8pt;padding-left:40px;text-align:left">
                      <li style="font-size:11pt; margin-bottom:1pt; line-height: 1.3; color:#000000""><strong style="font-weight:bold">Service providers —</strong> with vendors who perform services on our behalf, such as cloud hosting (including Amazon Web Services), payment processing, communications delivery, medical-expense review, customer support, and analytics. They may use the information only to perform services for us and are bound by contractual confidentiality and data-protection obligations.</li>
                      <li style="font-size:11pt; margin-bottom:1pt; line-height: 1.3; color:#000000""><strong style="font-weight:bold">Within our organization —</strong> with UHF affiliates and authorized personnel who need the information to perform their roles.</li>
                      <li style="font-size:11pt; margin-bottom:1pt; line-height: 1.3; color:#000000""><strong style="font-weight:bold">Professional advisors —</strong> with our attorneys, auditors, accountants, and insurers as needed to operate our organization.   </li>
                      <li style="font-size:11pt; margin-bottom:1pt; line-height: 1.3; color:#000000""><strong style="font-weight:bold">Legal and safety —</strong> with government agencies, law enforcement, or others when we believe in good faith that disclosure is required by law or legal process, or necessary to prevent harm, protect rights or safety, or investigate suspected fraud or unlawful activity.</li>
                      <li style="font-size:11pt; margin-bottom:1pt; line-height: 1.3; color:#000000""><strong style="font-weight:bold">Business transfers —</strong> with parties involved in a merger, acquisition, financing, reorganization, or sale or transfer of assets; any successor remains bound by this Policy or must provide notice of material changes.</li>
                    </ul>
                    <h2 style="font-size:13pt;margin:12pt 0 6pt; color:#253760; font-weight:bold">How We Protect Personal Information</h2>
                    <p style="font-size:11pt;margin:0 0 8pt;text-align:left; color:#000000;line-height:1.3">We maintain reasonable administrative, technical, and physical safeguards designed to protect personal information against loss, misuse, and unauthorized access, disclosure, alteration, or destruction, including encryption of personal information in transit and at rest, access controls, and monitoring. We limit access to authorized personnel and service providers who need it to perform their functions. No method of transmission or storage is completely secure, and we cannot guarantee absolute security; if a security incident affects your personal information, we will notify you and applicable regulators as required by law.</p>
                    <h2 style="font-size:13pt;margin:12pt 0 6pt; color:#253760; font-weight:bold">How Long We Retain Personal Information</h2>
                    <p style="font-size:11pt;margin:0 0 8pt;text-align:left; color:#000000;line-height:1.3">We retain personal information only as long as necessary to fulfill the purposes for which it was collected, to administer memberships and resolve disputes, and to comply with legal, accounting, and regulatory obligations. When it is no longer needed, we securely delete or de-identify it.</p>
                    <h2 style="font-size:13pt;margin:12pt 0 6pt; color:#253760; font-weight:bold">Your Privacy Rights</h2>
                    <p style="font-size:11pt;margin:0 0 8pt;text-align:left; color:#000000;line-height:1.3">Depending on where you live, you may have some or all of the following rights: to confirm whether we process your personal information and to access it; to receive a copy in a portable format; to correct inaccuracies; to request deletion; to opt out of the sale or sharing of personal information, targeted advertising, and certain profiling; and to appeal a denial of your request. Certain state laws also provide additional consent and access rights for consumer health data; where they apply, we honor them. We will not discriminate against you for exercising your rights.</p>
                    <p style="font-size:11pt;margin:0 0 8pt;text-align:left; color:#000000;line-height:1.3">To submit a request, contact us at <a href="mailto:info@UniversalHealthFellowship.org" style="color:#2e3192">info@UniversalHealthFellowship.org</a> or (888) 636-7119. We will verify your request as required by law and respond within the timeframes applicable in your state. You may use an authorized agent where permitted; we may require verification of the agent's authority.</p>
                    <h2 style="font-size:13pt;margin:12pt 0 6pt; color:#253760; font-weight:bold">Your Marketing Choices</h2>
                    <p style="font-size:11pt;margin:0 0 8pt;text-align:left; color:#000000;line-height:1.3">We send marketing communications only where permitted by law, and marketing consent is never a condition of membership. You may opt out of marketing emails via the "Unsubscribe" link or by contacting us at <a href="mailto:info@UniversalHealthFellowship.org" style="color:#2e3192">info@UniversalHealthFellowship.org</a>, and opt out of marketing texts by replying STOP. Opting out of marketing does not affect transactional or service messages relating to your membership.</p>
                    <h2 style="font-size:13pt;margin:12pt 0 6pt; color:#253760; font-weight:bold">Individuals Outside the United States</h2>
                    <p style="font-size:11pt;margin:0 0 8pt;text-align:left; color:#000000;line-height:1.3">UHF is based in the United States, and our programs and Services are intended only for individuals located in the United States. We do not offer our programs to, or knowingly collect personal information from, individuals outside the United States; if we learn we have inadvertently done so, we will take reasonable steps to delete the information.</p>
                    <h2 style="font-size:13pt;margin:12pt 0 6pt; color:#253760; font-weight:bold">Children's Privacy</h2>
                    <p style="font-size:11pt;margin:0 0 8pt;text-align:left; color:#000000;line-height:1.3">Our Services are intended for adults and are not directed to children under 13, and we do not knowingly collect personal information directly from children under 13. Where a membership includes minor dependents, we collect their information from the enrolling adult member and use it only to administer the membership. If you believe we have collected information directly from a child under 13, please contact us so we can delete it.</p>
                    <h2 style="font-size:13pt;margin:12pt 0 6pt; color:#253760; font-weight:bold">Links to Other Websites</h2>
                    <p style="font-size:11pt;margin:0 0 8pt;text-align:left; color:#000000;line-height:1.3">Our Services may link to third-party websites we do not control. We are not responsible for their privacy practices or content, and we encourage you to review their privacy notices.</p>
                    <h2 style="font-size:13pt;margin:12pt 0 6pt; color:#253760; font-weight:bold">Changes to This Privacy Policy</h2>
                    <p style="font-size:11pt;margin:0 0 8pt;text-align:left; color:#000000;line-height:1.3">We may update this Privacy Policy from time to time. When we do, we will revise the Effective Date above and post the updated Policy. For material changes, we will provide advance notice by email or prominent notice within the Services before the changes take effect.</p>
                    <h2 style="font-size:13pt;margin:12pt 0 6pt; color:#253760; font-weight:bold">How to Contact Us</h2>
                    <p style="font-size:11pt;margin:0 0 8pt;text-align:left; color:#000000;line-height:1.3">If you have questions about this Privacy Policy or our privacy practices, or wish to exercise your rights, contact: Universal Health Fellowship, Inc., Attn: Privacy Administrator, 4555 Mansell Road, Suite 300, Alpharetta, GA 30022 • <a href="mailto:info@UniversalHealthFellowship.org" style="color:#2e3192">info@UniversalHealthFellowship.org</a> • (888) 636-7119 • <a href="https://universalhealthfellowship.org/" target="_blank" rel="noopener noreferrer" style="color:#2e3192">www.UniversalHealthFellowship.org</a></p>
                  `
                }} />
              </Modal.Body>
              <Modal.Footer style={{ padding: '0px', height: '50px' }}>
                <CustomeButton
                  disabled={this.props.viewMode}
                  variant="contained"
                  onClick={event => this.hideModalPrivacy(event)}
                  style={{ marginBottom: '12px', marginTop: '5px', marginRight: '15px' }}
                >
                  {i18n.t('BUTTON.CANCEL')}
                </CustomeButton>
                <CustomeButton
                  disabled={this.props.viewMode}
                  variant="contained"
                  onClick={() => this.acceptPrivacyPolicy()}
                  style={{ marginBottom: '12px', marginTop: '5px', marginRight: '15px' }}
                >
                  {i18n.t('BUTTON.ACCEPT')}
                </CustomeButton>
              </Modal.Footer>
            </Modal>
          </div>

          <div className="d-flex flex-nowrap align-items-start">
            <Checkbox
              checked={this.state.authorize}
              inputProps={{
                'aria-label': 'secondary checkbox'
              }}
              disabled={this.props.viewMode}
              style={{ color: '#2e3192' }}
              onClick={this.showAuthorizeModalPopup}
            />
            <div className="mt-2">
              <span onClick={this.showAuthorizeModalPopup} style={{ cursor: 'pointer', fontWeight: '400' }}>
                {i18n.t('SUBMIT_APPLICATION.AUTHORIZE')}
              </span>
              <span
                style={{ color: '#2e3192', cursor: 'pointer', fontWeight: 'bold', borderBottom: '1px solid #2e3192' }}
                onClick={this.showAuthorizeModalPopup}
              >
                {i18n.t('SUBMIT_APPLICATION.AUTHORIZE11')}
              </span>
            </div>
          </div>

          <Modal size="lg" show={this.state.authModalShow} onHide={event => this.hideAllModal(event)} backdrop="static">
            <Modal.Header style={customStyle.modal_header} closeButton>
              <Modal.Title style={{ fontSize: '1rem', color: "#fff" }}>{i18n.t('SUBMIT_APPLICATION.IMP_NOTICE')}</Modal.Title>
            </Modal.Header>
            <Modal.Body
              style={{
                // 'maxHeight': '450px',
                // maxHeight: 'calc(100vh - 230px)',
                maxHeight: '60vh',
                overflowY: 'auto',
                textAlign: 'justify',
                wordSpacing: '1px'
              }}
            >
              <div>
                <div style={{ paddingTop: '8px', fontWeight: 'bold' }}>
                  Authorization for Universal Health Fellowship & CarynHealth to Contact Medical Provider
                </div>

                {/* <h2 style={{ wordSpacing: '1px', textAlign: 'left' }}>Authorization for Universal Health Fellowship & CarynHealth to Contact Medical Provider</h2> */}

                <p style={{ marginTop: '20px' }}>To Whom It May Concern:</p>
                <span>
                  I, a covered individual (or the parent or legal guardian for my minor) under{' '}
                  <span style={{ fontWeight: 'bold' }}>Universal HealthShare </span>(the “Program”), hereby request, authorize and grant
                  authority to Universal Health Fellowship (“UHF”), or its appointed health plan manager CarynHealth Solutions, LLC
                  (“CarynHealth”), to contact and act on my behalf in dealing with my physician and medical providers (the “Facility”) and
                  any other interested party in reference to charges for treatment, care and services provided in connection with the
                  medical need and medical billing (the “Medical Bill”), including without limitation charges that the Program has
                  determined exceed the Allowable Claim Limits under the terms of the Program Document.
                </span>
                <br />
                <br />
                <p>
                  Additionally, by my acceptance, I acknowledge that I have authorized the Facility to release any records and information
                  related to the Medical Bill, including Protected Health Information (PHI), to UHF and CarynHealth. I am requesting that
                  such Protected Health Information be disclosed under this authorization, as permitted by 164.508(1)(iv) of the privacy
                  regulations issued pursuant to the Health Insurance Portability and Accountability Act (“HIPAA Privacy Rule”). I have
                  retained a copy of this authorization for my records. I understand that I have the right to revoke this authorization in
                  writing, at any time, by sending a written statement of the revocation to UHF and CarynHealth. Unless revoked, this
                  release will remain in effect and valid for one year from the date of this authorization.
                </p>
              </div>
            </Modal.Body>
            <Modal.Footer style={{ padding: '0px' }}>
              <CustomeButton
                disabled={this.props.viewMode}
                variant="contained"
                onClick={event => this.authorizeHideModal(event)}
                style={{ marginBottom: '12px', marginTop: '5px', marginRight: '15px' }}
              >
                {i18n.t('BUTTON.CANCEL')}
              </CustomeButton>
              <CustomeButton
                disabled={this.props.viewMode}
                variant="contained"
                onClick={this.acceptAuth.bind(this)}
                style={{ marginBottom: '12px', marginTop: '5px', marginRight: '15px' }}
              >
                {i18n.t('BUTTON.ACCEPT')}
              </CustomeButton>
            </Modal.Footer>
          </Modal>
          {/* <div className="my-4 w-100">
                        <Sample setChild={this.nameChangeHandler.bind(this)} name={'FirstName'} reqFlag={true} label={'Approve  submission by typing in your full name'} value={this.state.fullName} disable={this.props.viewMode} style={customStyle.textFieldWrp} length={120} fieldType={'city'} errMsg={'Enter valid full name'} helperMsg={'Full name required'} parentDetails={{}}></Sample>
                    </div> */}
          <Row>
            <Col md={11} className="my-4">
              <Sample
                setChild={this.nameChangeHandler.bind(this)}
                name={'FirstName'}
                reqFlag={true}
                label={'Approve submission by typing in your full name'}
                value={this.state.fullName}
                disable={this.props.viewMode}
                style={customStyle.textFieldWrp}
                length={120}
                fieldType={'fullName'}
                errMsg={'Enter valid full name'}
                helperMsg={'Full name required'}
                parentDetails={{}}
              ></Sample>
            </Col>
          </Row>
        </Col>

        <Col md={5}>
          <Row className="d-flex flex-column px-1">
            <Col md={10} className="px-0 px-md-3">
              <div className="custom-subtitle"></div>
              <div className="description pt-0 pt-md-3" style={{ fontSize: '16px' }}>
                Your medical questionnaire is now ready to be submitted. Review the terms and indicate your acceptance of the same.
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
    )
  }
}

export default EnrollNew6
